const VISITOR_KEY = "site_visitor_id";

function randomId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `v_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
}

export function getSiteVisitorId() {
  if (typeof window === "undefined") {
    return "";
  }

  let id = localStorage.getItem(VISITOR_KEY);
  if (!id) {
    id = randomId();
    localStorage.setItem(VISITOR_KEY, id);
  }
  return id;
}

export function recordSitePageView(pathname, search = "") {
  if (typeof window === "undefined") {
    return;
  }

  const path = `${pathname || "/"}${search || ""}`;
  if (path.startsWith("/admin")) {
    return;
  }

  const userId = localStorage.getItem("user_id");
  const payload = {
    path,
    visitor_id: getSiteVisitorId(),
    user_id: userId ? Number(userId) : null,
    referrer: document.referrer || "",
  };

  const url = "/api/analytics/page-view";
  const body = JSON.stringify(payload);

  if (navigator.sendBeacon) {
    const blob = new Blob([body], { type: "application/json" });
    if (navigator.sendBeacon(url, blob)) {
      return;
    }
  }

  fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body,
    keepalive: true,
  }).catch(() => {});
}
